// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4793":"262d455b","4991":"61b34bc8","8038":"3ac5f649"}[chunkId] + ".chunk.css";
};